import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
// shared
import { DetailsContainer } from 'Components/shared/details-container'
// types
import { DataListType } from 'Types/common.types';
import { FetchedUserData } from 'Types/user.types';

interface PaymentDetailsProps {
    userDetails:FetchedUserData;
}

const PaymentDetails:React.FC<PaymentDetailsProps> = ({
    userDetails
}) => {

    const { t } = useTranslation();

    const paymentInfo: DataListType[] = [
        {
            label:t("label.bankType"),
            value:userDetails.userRole?.bankType ?? '-',
        },
        {
            label:t("label.accountNo"),
            value:userDetails.userRole?.accountNo ?? '-',
        },
        {
            label:t("label.socsoNo"),
            value:userDetails.userRole?.socsoNo ?? '-',
        },
        {
            label:t("label.epfNo"),
            value:userDetails.userRole?.epfNo ?? '-',
        },
        {
            label:t("label.incomeTax"),
            value:userDetails.userRole?.incomeTax ?? '-',
        },
        {
            label:t("label.hrdfNo"),
            value:userDetails.userRole?.hrdfNo ?? '-',
        },
        {
            label:t("label.zakatNo"),
            value:userDetails.userRole?.zakatNo ?? '-',
        },
    ]

  return (
    <div>
        <DetailsContainer
    listOfData={paymentInfo}
  />
  </div>
  )
}

export default PaymentDetails